module.exports = __webpack_public_path__ + "img/college_on.d3555179.png";